import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Button, Dialog, DialogTitle, Grid } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { ConfirmParts } from "pages/booking/dialogParts/ConfirmParts";
import { DisplayDate } from "pages/booking/dialogParts/DisplayDate";
import { BookingTypeName } from "pages/booking/dialogParts/BookingTypeName";
import { EventType } from "pages/statuses/EventType";
import * as CommonConstants from "utilities/CommonConstants";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        cancelButton: {
            marginRight: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        closeButton: {
            position: `absolute`,
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    })
);

interface Props {
    // 開くダイアログ選択
    isOpen: boolean;
    // キャンセル
    onClickCancel: VoidFunction;
    // 予約情報
    booking: EventType;
}

/**
 * 予約確認ダイアログコンポーネント
 * 予約情報を確認するときに呼び出されるコンポーネント
 */
export const ConfirmDialog: React.FC<Props> = (props) => {
    const { isOpen, onClickCancel, booking } = props;
    const classes = useStyles();
    const isPcSize = useMediaQuery(CommonConstants.RESPONSIVE_MIN_WIDTH);

    const body = (
        <div>
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClickCancel}>
                <CloseIcon />
            </IconButton>
            <DialogTitle id="form-dialog-title">
                <DisplayDate booking={booking} />
                <BookingTypeName booking={booking} />
            </DialogTitle>
            <ConfirmParts booking={booking} />
            <Grid container justify="flex-end">
                <Button color="primary" onClick={onClickCancel} className={classes.cancelButton}>
                    閉じる
                </Button>
            </Grid>
        </div>
    );

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullScreen={!isPcSize}
                open={isOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {body}
            </Dialog>
        </div>
    );
};
